import * as React from "react";
import { useAuth } from "./context/auth-context";

const AuthenticatedApp = React.lazy(() =>
  import(/* webpackPrefetch: true */ "./appAuth/authenticated-app")
);
const UnauthenticatedApp = React.lazy(() => import("./appAuth/unauthenticated-app"));

function App() {
  const { user } = useAuth();
  //console.log(user);
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      {user ? <AuthenticatedApp /> : <UnauthenticatedApp />}
    </React.Suspense>
  );
}

export default App;
